// @module BTM.SEOPriceCurrency.SEOPriceCurrency
define('BTM.SEOPriceCurrency.SEOPriceCurrency.View'
,	[
	'btm_seopricecurrency_seopricecurrency.tpl'
	
	,	'BTM.SEOPriceCurrency.SEOPriceCurrency.SS2Model'
	
	,	'Backbone'
    ]
, function (
	btm_seopricecurrency_seopricecurrency_tpl
	
	,	SEOPriceCurrencySS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class BTM.SEOPriceCurrency.SEOPriceCurrency.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_seopricecurrency_seopricecurrency_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new SEOPriceCurrencyModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BTM.SEOPriceCurrency.SEOPriceCurrency.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.SEOPriceCurrency.SEOPriceCurrency.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
